import { makeResetStyles, shorthands, tokens, } from '@fluentui/react-components';

export const useColorControlStyles = makeResetStyles({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  '& .eyeDropper': {
    width: '100%',
    position: 'relative',
    height: '148px',
    marginTop: '8px',
    marginBottom: '20px',
    '& .eye-dropper-button': {
      position: 'absolute',
      right: '20px',
      width: '40px',
      height: '40px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      bottom: '20px',
      ...shorthands.borderRadius('4px'),
      backgroundColor: tokens.colorNeutralBackground1,
      boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.14), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)',
    },
  },
  '& .design': {
    width: '100%',
    ...shorthands.padding('20px', '24px'),
    '& .design-title': {
      color: tokens.colorNeutralForeground3,
      fontWeight: tokens.fontWeightSemibold,
    },
    '& .design-color-chooser': {
      marginTop: '12px',
      display: 'flex',
      ...shorthands.gap('8px'),
      flexWrap: 'wrap',
      alignItems: 'center',
      '& .selected-color-wrapper': {
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ...shorthands.borderRadius('2px'),
        backgroundColor: tokens.colorNeutralBackground1Selected,
      },
      '& .add-color-button': {
        width: '32px',
        height: '32px',
        ...shorthands.borderRadius('9999px'),
        ...shorthands.border('2px', 'solid', '#616161'),
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        '& svg': {
          width: '20px',
          height: '20px',
        },
      },
    },
    '& .color-picker': {
      marginTop: '12px',
      '& .ms-ColorPicker-panel': {
        padding: 'unset',
      },
    },
  },
  '& .suggestion': {
    ...shorthands.padding('20px', '24px'),
    width: '100%',
    '& .suggestion-title': {
      color: tokens.colorNeutralForeground3,
      fontWeight: tokens.fontWeightSemibold,
    },
    '& .suggestion-color-chooser': {
      marginTop: '12px',
      ...shorthands.gap('8px'),
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
});
